// const server = "http://localhost";
// const domain = "localhost";
// const port = 9586;
const serverImg = 'https://avaflex.nbg1.your-objectstorage.com/public';
const server = "https://apiavaflex.mansolutions.app";
const port = 443;
const domain = "avaflex.mansolutions.app";
export { server, port, domain, serverImg };
